import Link from 'gatsby-link';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { MethodsService , DataStoreService} from 'utils';
import { HeroImage, Media } from '..';
import TeaserImageComponent from './subcomponents/image.component';
import {sortCaseServices} from '../../utils/helpers';

// import TextWrapperComponent from './subcomponents/textwrapper.component';


class CaseComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.delay = 0;
    this.state = {
      delay: 0,
      services: DataStoreService.getServices(),
    };


    this.caseCard = React.createRef();

    // this.setState(() => ({
    //  services: DataStoreService.getServices(),
    // }));
  }


  navigateToCase(event, slug) {
    const {
      teaserImageWide,
    } = this.props;
    event.preventDefault();
    MethodsService.getMethod('navigateWithTransition')(
      'toCase',
      <HeroImage
        image={teaserImageWide}
      />,
      this.caseCard.current.getBoundingClientRect(),
      `/${slug}`
    );
  }

  setDelay(delay) {
    this.setState({ delay: delay });
  }
  render() {
    const {
      teaserTitle,
      teaserImageWide,
      teaserImageTall,
      imageBackgroundColor,
      client,
      hover,
      slug,
      services,
      even,
      setServiceFilter,
    } = this.props;

    let teaserImage;
    if (teaserImageTall != null) {
      teaserImage = teaserImageTall;
    } else if (teaserImageWide != null) {
      teaserImage = teaserImageWide;
    }

    const sortedServices = sortCaseServices(this.state.services, this.props.services);

    return (
      <div>
        <Link to={`/work/${slug}`} onClick={event => this.navigateToCase(event, `work/${slug}`)}>
          <TeaserImageComponent
            data-cursor="focus"
            data-cursor-persistance="200"
            width="100%"
            maxWidth={1080}
            maxHeight={720}
            align="right"
            ref={el => (this.refbox = el)}
            className={hover ? 'hover' : ''}>
            <TeaserImageWrapper /*removed innerRef*/ ref={this.caseCard}>
              {teaserImage && <Media
                image={teaserImage}
                sizes={{
                  ...teaserImage.sizes,
                  aspectRatio: 3 / 2,
                }}
                autoplay={true}
                loop={true}
                backgroundColor={
                  imageBackgroundColor &&
                  imageBackgroundColor.hex
                }
              />}
            </TeaserImageWrapper>
            <TextWrapperComponent
              data-cursor="focus"
              data-cursor-persistance="200"
              css={TextWrapper}
              className={even ? 'even' : 'odd'}>
              <p css={client_css}>{client}</p>
              <p css={title}>{teaserTitle}</p>
            </TextWrapperComponent>
          </TeaserImageComponent>
        </Link>
        <p css={tags}>
          {sortedServices && sortedServices.map(service => <div className='dot-link' css={service_css} onClick={()=>setServiceFilter(service)} key={service}>{service}</div>)}
        </p>
      </div>
    );
  }
}


const TextWrapperComponent = styled.div`
    text-align: ${props => props.align || 'left'};
    right: ${props => props.right || 'auto'};
    left: ${props => props.left || 'auto'};
    position: absolute;
    z-index: 1;
    bottom: 20%;

`;

const TeaserImageWrapper = styled.div`
    /* padding-bottom: 58%; */
    /* position: relative;
    overflow: hidden; */

    & > div{
      /* position: absolute !important; */
    }

    video{
      /* transform: scale(1.1); */
    }
`;

const TextWrapper = css`
    left: 0;
    position: relative;
    margin-top: 1rem;
`;
const client_css = css`
    margin-bottom: 0.5rem;
    font-weight: 700;
`;
const title = css`
    white-space: normal;
    margin-bottom: 1rem;
    @media only screen and (min-width: 500px){
      min-height: 2.6rem;
    }
`;
const tags = css`
  min-height: 2rem;
  
`;
const service_css = css`
  font-size: 13px;
  margin-left: -.65rem;
  margin-right: 1rem;
  // opacity: 0.5;
  // position: relative;
  // display: inline-block;
  // cursor: pointer;
  // &:before{
  //   margin-right: .35rem;
  //   display: inline-block;
  //   vertical-align: middle;
  //   content: "";
  //   width: .25rem;
  //   height: .25rem;
  //   border-radius: 100%;
  //   background-color: #111;
  //   opacity: 0;
  // }
  // &:hover{
  //   opacity: 1;
  // }
  // &:hover:before{
  //   opacity: 1;
  // }
`;

export default CaseComponent;
